<template>
  <div class="affiliate-payouts-tab" :class="{ 'is-preview': preview }">
    <div v-if="!preview" class="affiliate-activity-summary">
      <article class="affiliate-mini-card">
        <div class="affiliate-mini-card__icon is-approved" aria-hidden="true">
          <svg width="20" height="18" viewBox="0 0 36 32" fill="none">
            <path d="M22.8571 19.0477C22.8571 17.6332 23.419 16.2767 24.4192 15.2765C25.4194 14.2763 26.776 13.7144 28.1905 13.7144H32V10.6668C32 9.85847 31.6789 9.0833 31.1074 8.51176C30.5358 7.94022 29.7607 7.61913 28.9524 7.61913H3.04762C1.92099 7.62168 0.834049 7.20321 0 6.4458V27.4287C0 28.6411 0.481631 29.8038 1.33894 30.6611C2.19625 31.5185 3.35901 32.0001 4.57143 32.0001H28.9524C30.1648 32.0001 31.3276 31.5185 32.1849 30.6611C33.0422 29.8038 33.5238 28.6411 33.5238 27.4287V24.381H28.1905C26.776 24.381 25.4194 23.8191 24.4192 22.8189C23.419 21.8187 22.8571 20.4622 22.8571 19.0477Z" fill="currentColor"/>
            <path d="M33.5237 15.238H28.1904C27.18 15.238 26.2111 15.6394 25.4966 16.3538C24.7822 17.0682 24.3809 18.0372 24.3809 19.0476C24.3809 20.0579 24.7822 21.0269 25.4966 21.7413C26.2111 22.4557 27.18 22.8571 28.1904 22.8571H33.5237C33.9279 22.8571 34.3154 22.6965 34.6012 22.4108C34.887 22.125 35.0475 21.7374 35.0475 21.3333V16.7618C35.0475 16.3577 34.887 15.9701 34.6012 15.6844C34.3154 15.3986 33.9279 15.238 33.5237 15.238ZM28.9523 20.5714C28.6509 20.5714 28.3563 20.482 28.1057 20.3146C27.8551 20.1471 27.6598 19.9091 27.5445 19.6307C27.4291 19.3523 27.399 19.0459 27.4578 18.7503C27.5166 18.4547 27.6617 18.1832 27.8748 17.9701C28.0879 17.757 28.3594 17.6118 28.655 17.553C28.9506 17.4942 29.257 17.5244 29.5354 17.6397C29.8139 17.7551 30.0519 17.9504 30.2193 18.201C30.3867 18.4516 30.4761 18.7462 30.4761 19.0476C30.4761 19.4517 30.3156 19.8393 30.0298 20.1251C29.744 20.4108 29.3564 20.5714 28.9523 20.5714Z" fill="currentColor"/>
            <path d="M3.04762 6.09524H28.9524C30.1648 6.09524 31.3276 6.57687 32.1849 7.43418C33.0422 8.29149 33.5238 9.45425 33.5238 10.6667V4.57143C33.5238 3.35901 33.0422 2.19625 32.1849 1.33894C31.3276 0.481631 30.1648 0 28.9524 0H3.04762C2.23934 0 1.46417 0.321087 0.892627 0.892627C0.321088 1.46417 0 2.23934 0 3.04762C0 3.8559 0.321088 4.63107 0.892627 5.20261C1.46417 5.77415 2.23934 6.09524 3.04762 6.09524Z" fill="currentColor"/>
          </svg>
        </div>
        <div>
          <div class="affiliate-mini-card__value">{{ money(availableToWithdraw) }}</div>
          <div class="affiliate-mini-card__label">Available to withdraw</div>
        </div>
      </article>
      <article class="affiliate-mini-card">
        <div class="affiliate-mini-card__icon is-pending" aria-hidden="true">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="8.25" stroke="currentColor" stroke-width="1.8"/>
            <path d="M12 8v4.2l2.4 1.4" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <div>
          <div class="affiliate-mini-card__value">{{ money(pendingApproval) }}</div>
          <div class="affiliate-mini-card__label">{{ pendingLabel }}</div>
        </div>
      </article>
      <article class="affiliate-mini-card">
        <div class="affiliate-mini-card__icon is-paid-out" aria-hidden="true">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
            <path d="M12 19V5M12 5L6 11M12 5L18 11" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <div>
          <div class="affiliate-mini-card__value">{{ money(paidOutAmount) }}</div>
          <div class="affiliate-mini-card__label">{{ paidOutLabel }}</div>
        </div>
      </article>
    </div>

    <div class="affiliate-activity-card" :class="{ 'is-preview': preview }">
      <div class="affiliate-activity-card__head">
        <div class="affiliate-activity-card__title-row">
          <div class="affiliate-activity-card__title">{{ preview ? "Payouts" : "Payout history" }}</div>
          <div class="affiliate-payouts-head-actions">
            <button
              v-if="preview"
              type="button"
              class="affiliate-activity-view-all"
              @click="$emit('view-all')"
            >
              View all {{ historyPayouts.length }}
            </button>
            <button
              type="button"
              class="affiliate-withdraw-btn"
              @click="toggleWithdraw"
            >
              {{ withdrawOpen ? "Close" : "Withdraw funds" }}
            </button>
          </div>
        </div>
        <p v-if="preview" class="affiliate-activity-card__sub">
          Latest {{ displayedRows.length }}.
        </p>
      </div>

      <div v-if="preview" class="affiliate-payout-strip">
        <div class="affiliate-payout-strip__item">
          <div class="affiliate-payout-strip__label">Available</div>
          <div class="affiliate-payout-strip__value is-available">{{ money(availableToWithdraw) }}</div>
        </div>
        <div class="affiliate-payout-strip__item">
          <div class="affiliate-payout-strip__label">Pending approval</div>
          <div class="affiliate-payout-strip__value">{{ money(pendingApproval) }}</div>
          <div v-if="clearingDate" class="affiliate-payout-strip__meta">
            clears {{ formatMonthDay(clearingDate) }}
          </div>
        </div>
        <div class="affiliate-payout-strip__item">
          <div class="affiliate-payout-strip__label">Paid out all-time</div>
          <div class="affiliate-payout-strip__value">{{ money(paidOutAmount) }}</div>
        </div>
      </div>

      <div v-if="withdrawOpen" class="affiliate-withdraw-panel">
        <div class="affiliate-withdraw-panel__methods">
          <div class="affiliate-withdraw-panel__label">Pay via</div>
          <div class="affiliate-withdraw-methods">
            <button
              type="button"
              class="affiliate-withdraw-method"
              :class="{ active: withdrawMethod === 'wallet' }"
              @click="withdrawMethod = 'wallet'"
            >
              <span class="affiliate-withdraw-method__check" v-if="withdrawMethod === 'wallet'"></span>
              <span class="affiliate-withdraw-method__icon is-wallet" aria-hidden="true">
                <svg width="18" height="16" viewBox="0 0 36 32" fill="none">
                  <path d="M22.8571 19.0477C22.8571 17.6332 23.419 16.2767 24.4192 15.2765C25.4194 14.2763 26.776 13.7144 28.1905 13.7144H32V10.6668C32 9.85847 31.6789 9.0833 31.1074 8.51176C30.5358 7.94022 29.7607 7.61913 28.9524 7.61913H3.04762C1.92099 7.62168 0.834049 7.20321 0 6.4458V27.4287C0 28.6411 0.481631 29.8038 1.33894 30.6611C2.19625 31.5185 3.35901 32.0001 4.57143 32.0001H28.9524C30.1648 32.0001 31.3276 31.5185 32.1849 30.6611C33.0422 29.8038 33.5238 28.6411 33.5238 27.4287V24.381H28.1905C26.776 24.381 25.4194 23.8191 24.4192 22.8189C23.419 21.8187 22.8571 20.4622 22.8571 19.0477Z" fill="currentColor"/>
                  <path d="M33.5237 15.238H28.1904C27.18 15.238 26.2111 15.6394 25.4966 16.3538C24.7822 17.0682 24.3809 18.0372 24.3809 19.0476C24.3809 20.0579 24.7822 21.0269 25.4966 21.7413C26.2111 22.4557 27.18 22.8571 28.1904 22.8571H33.5237C33.9279 22.8571 34.3154 22.6965 34.6012 22.4108C34.887 22.125 35.0475 21.7374 35.0475 21.3333V16.7618C35.0475 16.3577 34.887 15.9701 34.6012 15.6844C34.3154 15.3986 33.9279 15.238 33.5237 15.238Z" fill="currentColor"/>
                </svg>
              </span>
              <span class="affiliate-withdraw-method__name">Wallet credit</span>
              <span class="affiliate-withdraw-method__meta">Instant · no minimum</span>
            </button>
            <button
              type="button"
              class="affiliate-withdraw-method"
              :class="{ active: withdrawMethod === 'paypal' }"
              @click="withdrawMethod = 'paypal'"
            >
              <span class="affiliate-withdraw-method__check" v-if="withdrawMethod === 'paypal'"></span>
              <span class="affiliate-withdraw-method__icon is-paypal" aria-hidden="true">
                <svg width="16" height="18" viewBox="0 0 24 24" fill="none">
                  <path d="M7.2 21H4.6c-.4 0-.7-.4-.6-.8L7.6 3.7c.1-.4.4-.7.8-.7h6.3c3.2 0 5.2 1.6 4.8 4.6-.4 3.2-2.6 4.9-5.8 4.9H10l-.7 4.5H12" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </span>
              <span class="affiliate-withdraw-method__name">PayPal</span>
              <span class="affiliate-withdraw-method__meta">{{ paypalMethodMeta }}</span>
            </button>
          </div>
        </div>
        <div class="affiliate-withdraw-panel__amount">
          <template v-if="withdrawMethod === 'paypal' && !hasPaypalDetails()">
            <div class="affiliate-withdraw-panel__label">PayPal Email Address *</div>
            <input
              v-model="paypalEmailInput"
              type="email"
              class="affiliate-withdraw-paypal-input"
              :class="{ 'is-invalid': !!paypalEmailError }"
              placeholder="yourname@example.com"
              @input="paypalEmailError = ''"
            />
            <span v-if="paypalEmailError" class="affiliate-withdraw-paypal-error">{{ paypalEmailError }}</span>
            <div class="affiliate-withdraw-panel__label">PayPal Account Holder Name (Optional)</div>
            <input
              v-model="paypalNameInput"
              type="text"
              class="affiliate-withdraw-paypal-input"
              placeholder="Full name or business name"
            />
            <label class="affiliate-withdraw-paypal-confirm">
              <input v-model="paypalConfirmInput" type="checkbox" @change="paypalConfirmError = ''" />
              <span>I confirm that my PayPal email address is correct and can receive payments.</span>
            </label>
            <span v-if="paypalConfirmError" class="affiliate-withdraw-paypal-error">{{ paypalConfirmError }}</span>
          </template>
          <div class="affiliate-withdraw-panel__label">Amount</div>
          <div class="affiliate-withdraw-amount">
            <span class="affiliate-withdraw-amount__prefix">$</span>
            <input
              v-model.number="withdrawAmount"
              type="number"
              min="0"
              step="0.01"
              class="affiliate-withdraw-amount__input"
            />
            <button type="button" class="affiliate-withdraw-max" @click="setMaxAmount">Max</button>
          </div>
          <p class="affiliate-withdraw-hint">{{ withdrawHint }}</p>
          <button
            type="button"
            class="affiliate-withdraw-submit"
            :disabled="!canSubmitWithdraw"
            @click="submitWithdraw"
          >
            {{ withdrawSubmitLabel }}
          </button>
        </div>
      </div>

      <div v-if="!preview" class="affiliate-activity-filters">
        <input
          v-model="search"
          type="text"
          class="affiliate-activity-search"
          placeholder="Search transaction ID..."
          @input="page = 1"
        />
        <select v-model="methodFilter" class="affiliate-activity-select" @change="page = 1">
          <option value="all">All methods</option>
          <option v-for="method in methodOptions" :key="method.value" :value="method.value">
            {{ method.label }}
          </option>
        </select>
        <select v-model="statusFilter" class="affiliate-activity-select" @change="page = 1">
          <option value="all">All statuses</option>
          <option value="completed">Completed</option>
          <option value="pending">Pending</option>
        </select>
        <select v-model="dateRange" class="affiliate-activity-select" @change="page = 1">
          <option value="all">All time</option>
          <option :value="30">Last 30 days</option>
          <option :value="90">Last 90 days</option>
          <option :value="365">Last 12 months</option>
        </select>
    </div>

    <div class="table-responsive">
        <table class="affiliate-activity-table">
          <thead>
          <tr>
            <th>Date</th>
            <th>Payout</th>
            <th>Pay via</th>
            <th>Transaction ID</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="!displayedRows.length">
              <td colspan="5" class="affiliate-activity-empty">No payouts yet.</td>
          </tr>
            <tr v-for="(row, index) in displayedRows" :key="rowKey(row, index)">
              <td>{{ formatDate(row.paid_at) }}</td>
              <td class="affiliate-payout-amount">{{ money(row.payout) }}</td>
              <td>{{ methodLabel(row) }}</td>
              <td>{{ row.transaction_id || "—" }}</td>
              <td>
                <span class="affiliate-status-pill" :class="statusClass(row)">
                  <span class="affiliate-status-dot"></span>
                  {{ statusLabel(row) }}
                </span>
              </td>
          </tr>
          </tbody>
        </table>
      </div>

      <template v-if="!preview && filteredRows.length">
        <div class="affiliate-activity-footer">
          <div class="total-records-list">
            <p>Showing {{ displayedRows.length }} of {{ filteredRows.length }} records</p>
          </div>
          <div class="per-page-right-box">
            <div class="select-item">
              <select v-model.number="perPage" @change="changePagination()">
                <option :value="50">50</option>
                <option :value="100">100</option>
                <option :value="200">200</option>
                <option :value="500">500</option>
              </select>
            </div>
          </div>
        </div>
        <div class="pagination-list" v-if="lastPage > 1">
          <paginate
            :click-handler="goToPage"
            :prev-text="'Prev'"
            :next-text="'Next'"
            :page-count="lastPage"
            :page-range="3"
            :margin-pages="2"
            :container-class="'className'"
            :records="filteredRows.length"
            v-model="page"
            :per-page="perPage"
          />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { numberFormat } from "@/prod.js";
import { truncateMoney } from "@/utils/money.js";
import Paginate from "vuejs-paginate-next";
import moment from "moment";

const PAYPAL_EMAIL_REGEX =
  /^(?!.*\.\.)(?!.*__)[a-zA-Z0-9]+(?:[._-][a-zA-Z0-9]+)*@[a-zA-Z0-9]+(?:[.-][a-zA-Z0-9]+)*\.[a-zA-Z]{2,}$/;

const METHOD_LABELS = {
  wallet: "Wallet credit",
  "wallet credit": "Wallet credit",
  credit: "Wallet credit",
  balance: "Wallet credit",
  paypal: "PayPal",
  bank: "Bank transfer",
  "bank transfer": "Bank transfer",
  transfer: "Bank transfer",
  wire: "Bank transfer",
};

export default {
  components: {
    Paginate,
  },
  props: {
    earning_lists: {
      type: Array,
      default: () => [],
    },
    historyPayouts: {
      type: Array,
      default: () => [],
    },
    affiliateStatsData: {
      default: () => ({}),
    },
    showPayoutBtn: {
      type: Boolean,
      default: false,
    },
    preview: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["submit-withdraw", "view-all"],
  data() {
    return {
      numberFormat,
      truncateMoney,
      search: "",
      methodFilter: "all",
      statusFilter: "all",
      dateRange: "all",
      page: 1,
      perPage: 50,
      withdrawOpen: false,
      withdrawMethod: "wallet",
      withdrawAmount: 0,
      paypalEmail: "",
      paypalEmailInput: "",
      paypalEmailError: "",
      paypalNameInput: "",
      paypalConfirmInput: false,
      paypalConfirmError: "",
      hasPayoutDetails: false,
      withdrawing: false,
    };
  },
  methods: {
    money(value) {
      return this.numberFormat(this.truncateMoney(value), "currency");
    },
    setMaxAmount() {
      this.withdrawAmount = this.truncateMoney(this.availableToWithdraw);
    },
    hasPaypalDetails() {
      return !!String(this.paypalEmail || "").trim();
    },
    isValidPaypalEmail(value) {
      return PAYPAL_EMAIL_REGEX.test(String(value || "").trim());
    },
    async toggleWithdraw() {
      if (this.withdrawOpen) {
        this.withdrawOpen = false;
        return;
      }
      this.withdrawMethod = "wallet";
      this.paypalEmailInput = "";
      this.paypalEmailError = "";
      this.paypalNameInput = "";
      this.paypalConfirmInput = false;
      this.paypalConfirmError = "";
      this.setMaxAmount();
      try {
        const res = await this.$store.dispatch("Profile/getPayoutDetailsDataAction");
        this.hasPayoutDetails = !!(res && res.success);
        this.paypalEmail = (res && res.paypal_email) || "";
      } catch (error) {
        this.hasPayoutDetails = false;
        this.paypalEmail = "";
      }
      this.withdrawOpen = true;
    },
    async savePaypalEmail() {
      const email = String(this.paypalEmailInput || "").trim();
      if (!this.isValidPaypalEmail(email)) {
        this.paypalEmailError = "The email format is invalid.";
        return false;
      }
      if (!this.paypalConfirmInput) {
        this.paypalConfirmError = "Please confirm that your PayPal email address is correct.";
        return false;
      }
      this.paypalConfirmError = "";
      try {
        const res = await this.$store.dispatch("Profile/savePayoutDetailsDataAction", {
          paypal_email: email,
          paypal_account_holder_name: String(this.paypalNameInput || "").trim(),
          paypal_email_confirmed: 1,
          payoutBy: "paypal",
        });
        if (res && res.success) {
          this.paypalEmail = email;
          this.paypalEmailError = "";
          return true;
        }
        this.paypalEmailError = (res && res.message) || "Unable to save PayPal email.";
        return false;
      } catch (error) {
        this.paypalEmailError =
          error.response?.data?.errors?.paypal_email?.[0] ||
          error.response?.data?.error ||
          "Unable to save PayPal email.";
        this.paypalConfirmError =
          error.response?.data?.errors?.paypal_email_confirmed?.[0] || "";
        return false;
      }
    },
    async submitWithdraw() {
      if (!this.canSubmitWithdraw) return;
      if (this.withdrawMethod === "paypal" && !this.hasPaypalDetails()) {
        this.withdrawing = true;
        const saved = await this.savePaypalEmail();
        this.withdrawing = false;
        if (!saved) return;
      }
      this.$emit("submit-withdraw", {
        method: this.withdrawMethod,
        amount: Number(this.withdrawAmount),
      });
    },
    closeWithdraw() {
      this.withdrawOpen = false;
      this.withdrawing = false;
      this.paypalEmailInput = "";
      this.paypalEmailError = "";
      this.paypalNameInput = "";
      this.paypalConfirmInput = false;
      this.paypalConfirmError = "";
    },
    goToPage(pageNum) {
      this.page = pageNum;
    },
    changePagination() {
      this.page = 1;
    },
    rowKey(row, index) {
      return row.transaction_id || `${row.paid_at}-${row.status}-${index}`;
    },
    parseDate(value) {
      if (!value) return null;
      const formats = [
        moment.ISO_8601,
        "YYYY-MM-DD HH:mm:ss",
        "YYYY-MM-DD",
        "MM/DD/YYYY",
        "DD/MM/YYYY",
        "MMM DD, YYYY",
        "D MMM YYYY",
        "MMMM D, YYYY",
      ];
      const parsed = moment(value, formats, true);
      if (parsed.isValid()) return parsed;
      const loose = moment(value);
      return loose.isValid() ? loose : null;
    },
    formatDate(value) {
      const date = this.parseDate(value);
      return date ? date.format("MMM DD, YYYY") : value || "—";
    },
    formatMonthDay(date) {
      return date ? date.format("MMM DD") : "";
    },
    methodKey(row) {
      return String(row.pay_via || row.type || "")
        .trim()
        .toLowerCase();
    },
    methodLabel(row) {
      const key = this.methodKey(row);
      if (!key) return "—";
      if (METHOD_LABELS[key]) return METHOD_LABELS[key];
      return String(row.pay_via || row.type);
    },
    normalizedStatus(row) {
      return String(row.status || "completed").toLowerCase();
    },
    statusLabel(row) {
      const status = this.normalizedStatus(row);
      if (status === "paid" || status === "completed") return "Completed";
      if (status === "requested" || status === "pending") return "Pending";
      return row.status || "Completed";
    },
    statusClass(row) {
      const status = this.normalizedStatus(row);
      if (status === "requested" || status === "pending") return "is-pending";
      return "is-completed";
    },
    matchesSearch(row) {
      const query = this.search.trim().toLowerCase();
      if (!query) return true;
      return String(row.transaction_id || "")
        .toLowerCase()
        .includes(query);
    },
    matchesMethod(row) {
      if (this.methodFilter === "all") return true;
      return this.methodKey(row) === this.methodFilter;
    },
    matchesStatus(row) {
      if (this.statusFilter === "all") return true;
      const status = this.normalizedStatus(row);
      if (this.statusFilter === "completed") {
        return status === "completed" || status === "paid";
      }
      if (this.statusFilter === "pending") {
        return status === "pending" || status === "requested";
      }
      return true;
    },
    matchesDate(row) {
      if (this.dateRange === "all") return true;
      const date = this.parseDate(row.paid_at);
      if (!date) return true;
      return date.isSameOrAfter(moment().subtract(Number(this.dateRange), "days"), "day");
    },
    isHoldRow() {
      return false;
    },
  },
  computed: {
    statsSource() {
      const raw = this.affiliateStatsData;
      if (!raw || Array.isArray(raw)) return {};
      if (
        raw.data &&
        typeof raw.data === "object" &&
        !Array.isArray(raw.data) &&
        (raw.data.total_earning !== undefined ||
          raw.data.paid_bonus !== undefined ||
          raw.data.unpaid_bonus !== undefined)
      ) {
        return raw.data;
      }
      return raw;
    },
    holdRows() {
      return (this.earning_lists || []).filter((row) => this.isHoldRow(row));
    },
    availableToWithdraw() {
      if (
        this.statsSource.available_to_withdraw !== undefined &&
        this.statsSource.available_to_withdraw !== null
      ) {
        return Number(this.statsSource.available_to_withdraw) || 0;
      }
      return Number(this.statsSource.unpaid_bonus || 0);
    },
    pendingApproval() {
      const fromHistory = (this.historyPayouts || []).reduce((sum, row) => {
        const status = String(row.status || "").toLowerCase();
        if (status === "pending" || status === "requested") {
          return sum + (Number(row.payout) || 0);
        }
        return sum;
      }, 0);
      if (fromHistory > 0) return fromHistory;
      return Number(this.statsSource.pending_clearing) || 0;
    },
    clearingDate() {
      const apiDate = this.parseDate(this.statsSource.clearing_date);
      if (apiDate) return apiDate;
      const dates = this.holdRows
        .map((row) => {
          const created = this.parseDate(row.created_at);
          return created ? created.clone().add(14, "days") : null;
        })
        .filter(Boolean)
        .sort((a, b) => a.valueOf() - b.valueOf());
      return dates[0] || null;
    },
    pendingLabel() {
      const date = this.formatMonthDay(this.clearingDate);
      return date ? `Pending approval · clears ${date}` : "Pending approval";
    },
    paidOutAmount() {
      return Number(this.statsSource.paid_bonus || 0);
    },
    payoutCount() {
      if (this.statsSource.payout_count !== undefined) {
        return Number(this.statsSource.payout_count) || 0;
      }
      return (this.historyPayouts || []).filter((row) => {
        const status = String(row.status || "completed").toLowerCase();
        return status === "completed" || status === "paid";
      }).length;
    },
    paidOutLabel() {
      const count = this.payoutCount;
      return `Paid out all-time · ${count} ${count === 1 ? "payout" : "payouts"}`;
    },
    sortedRows() {
      return [...(this.historyPayouts || [])].sort((a, b) => {
        const aDate = this.parseDate(a.paid_at);
        const bDate = this.parseDate(b.paid_at);
        if (aDate && bDate) return bDate.valueOf() - aDate.valueOf();
        return 0;
      });
    },
    methodOptions() {
      const seen = {};
      return this.sortedRows
        .map((row) => {
          const value = this.methodKey(row);
          if (!value || seen[value]) return null;
          seen[value] = true;
          return { value, label: this.methodLabel(row) };
        })
        .filter(Boolean);
    },
    filteredRows() {
      return this.sortedRows.filter(
        (row) =>
          this.matchesSearch(row) &&
          this.matchesMethod(row) &&
          this.matchesStatus(row) &&
          this.matchesDate(row)
      );
    },
    lastPage() {
      return Math.max(1, Math.ceil(this.filteredRows.length / this.perPage));
    },
    displayedRows() {
      if (this.preview) return this.sortedRows.slice(0, 4);
      const start = (this.page - 1) * this.perPage;
      return this.filteredRows.slice(start, start + this.perPage);
    },
    paypalMethodMeta() {
      return this.paypalEmail || "Add PayPal email below";
    },
    withdrawHint() {
      if (this.withdrawMethod === "paypal") {
        return this.paypalEmail
          ? `Sent to ${this.paypalEmail}.`
          : "Enter your PayPal email here, then request the payout.";
      }
      return "Credited to your wallet immediately.";
    },
    withdrawSubmitLabel() {
      if (this.withdrawMethod === "paypal") {
        return this.hasPaypalDetails() ? "Request PayPal payout" : "Save & request PayPal payout";
      }
      return "Add to wallet";
    },
    canSubmitWithdraw() {
      const amount = Number(this.withdrawAmount);
      if (!amount || amount <= 0) return false;
      if (amount > Number(this.availableToWithdraw) + 0.001) return false;
      if (this.withdrawMethod === "paypal" && !this.hasPaypalDetails()) {
        if (!this.isValidPaypalEmail(this.paypalEmailInput) || !this.paypalConfirmInput) {
          return false;
        }
      }
      if (this.withdrawing) return false;
      return true;
    },
  },
};
</script>
